enum SwiftFeePayee {
  Sha = 1,
  Our = 2
}

export default SwiftFeePayee;
